
export default {
  code: "pt-br",
  buttonText: {
    prev: "Anterior",
    next: "Próximo",
    today: "Hoje",
    month: "Mês",
    week: "Semana",
    day: "Dia",
    list: "Compromissos"
  },
  weekLabel: "Sm",
  allDayText: "dia inteiro",
  eventLimitText: function(n) {
    return "mais +" + n;
  },
  noEventsMessage: "Não há eventos para mostrar"
};
